export default {
  useMfaServicesV2__NO_DEVICES_FOUND:
    "No valid contact information found. Please contact customer support to update your contact details.",
};
